import {Component, HostBinding, OnInit, ViewChild} from '@angular/core';
import {AppConfig} from '@app/models/app-config.model';
import {ConfigService} from '@app/services/config.service';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmationService} from 'primeng/components/common/api';
import {ConfirmDialog} from 'primeng/components/confirmdialog/confirmdialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  providers: [ConfirmationService]
})
export class ConfirmDialogComponent implements OnInit {

  @HostBinding('class.ui-dialog-error') private _isError = false;
  @HostBinding('class.ui-dialog-warning') private _isWarning = false;

  @ViewChild(ConfirmDialog)
  public confirmDialog: ConfirmDialog;
  public type: string;
  public rejectLabel: string;
  public acceptLabel: string;

  private closeResolver: Function;

  constructor(private i18n: TranslateService,
              private confirmationService: ConfirmationService,
              private config: ConfigService) {
  }


  ngOnInit(): void {
  }

  showConfirmMsg(type: string, msg: string, title?: string, icon?: string, dungeonKeeper: boolean = false): Promise<boolean> {
    if (dungeonKeeper) {
      this.rejectLabel = this.i18n.instant('common.no-dungen-keeper');
      this.acceptLabel = this.i18n.instant('common.yes-dungen-keeper');
    }
    else {
      this.rejectLabel = this.i18n.instant('common.no');
      this.acceptLabel = this.i18n.instant('common.yes');
    }

    return new Promise<boolean>((resolve, reject) => {
      const appConfig = <AppConfig>this.config.app;

      this.type = type;
      this.closeResolver = resolve;
      this._isError = false;
      this._isWarning = false;

      if (appConfig.dialogConfirmWidth)
        this.confirmDialog.width = appConfig.dialogConfirmWidth;

      if (type === 'error') {
        icon = 'ui-icon-error';
        this._isError = true;

        if (appConfig.dialogErrorWidth)
          this.confirmDialog.width = appConfig.dialogErrorWidth;

      }
      else if (type === 'warning') {
        icon = 'ui-icon-warning';
        this._isWarning = true;
      }

      this.confirmationService.confirm({
        message: msg,
        header: title || this.i18n.instant(`common.${type}`),
        icon: icon || ((type === 'delete') ? 'ui-icon-delete-forever' : 'ui-icon-help'),
        accept: () => {
          this.closeResolver(true);
        },
        reject: () => {
          this.closeResolver(false);
        }
      });
    });
  }

  get isError(): boolean {
    return this._isError;
  }
}
